
import { Watch, Prop, Component, Vue } from 'vue-property-decorator'
import { WinckFilter, WinckFilterConfig } from '@/api/client/winck-proxy'
import { namespace } from 'vuex-class'
const narrowcasting = namespace('narrowcasting')

@Component
export default class BaseField extends Vue {
    @Prop({ default: () => [] }) readonly value!: any|string[]
    @narrowcasting.State readonly filterConfigs!: WinckFilterConfig[]
    internalValue: any = null
    enabled: boolean = false

    mounted(): void {
        this.internalValue = this.value
        this.enabled = Object.values(this.internalValue)
            .filter(v => !!v)
            .length > 0

        this.applyInitialValues()
    }

    applyInitialValues(): void {
        const x = null // block mag niet leeg zijn van tslint :(
    }

    @Watch('enabled')
    onVisibilityChanged(): void {
        this.$emit(this.enabled ? 'enabled' : 'disabled', this.filter)
    }

    @Watch('fieldValues')
    onValueChanged(): void {
        if (this.enabled) {
            this.$emit('input', this.filter)
        }
    }

    get fieldName(): string {
        return 'base_field'
    }

    get fieldValues(): object|string[] {
        return this.internalValue
    }

    get filter(): WinckFilter {
        return {
            field: this.fieldName,
            fieldValues: this.fieldValues,
        }
    }

    get filterConfig(): WinckFilterConfig {
        return this.filterConfigs.find(entry => entry.name === this.fieldName)
    }
}
